import React from "react"

import Slider, { SliderProps } from "@react-native-community/slider"

import { useTheme } from "../theme"

export type SliderInputProps = Pick<
  SliderProps,
  "value" | "maximumValue" | "minimumValue" | "style"
> & { step: number; onChange?: (value: number) => void }

const MAX_HEIGHT = 30

export function SliderInput(props: SliderInputProps) {
  const { color } = useTheme()

  return (
    <Slider
      {...props}
      value={props.value}
      thumbTintColor={color.secondary1}
      maximumTrackTintColor={color.accent}
      minimumTrackTintColor={color.primary}
      style={[{ maxHeight: MAX_HEIGHT }, props.style]}
      onValueChange={props.onChange}
    />
  )
}
